import { getItem, paginateFromEnd, setItem } from './index';

const KEY = 'chat_h_c_v1'; // chat_history_character_v1
class ChatSession {
  getStore() {
    return getItem(KEY) || {};
  }

  // [
  //   {
  //     avatar:"www", // 头像地址
  //     characterName:"1",  // 人物名称
  //     characterId:"1", // 人物id
  //     chatTime: 1748258529107, // 聊天时间
  //     description: "description", // 描述
  //     sessionId: "57503_1_1748256462", // 会话id
  //     type: 'text', // 'text' | 'img'
  //     content: "content", // 聊天内容
  //     msgType: "aiMsg", // 前端展示用
  //    }
  //  ]
  getChatList() {
    const store = this.getStore();
    const result = Object.keys(store).reduce((res, id) => {
      const chatInfo = store[id] || {};
      const {
        list = [], characterId, characterName, sessionId, avatar, description,
      } = chatInfo;
      if (!list.length) return res;
      const last = list[list.length - 1] || {};
      res.push({
        characterName,
        characterId,
        sessionId,
        avatar,
        description,
        ...last,
      });
      return res;
    }, []);
    return result.sort((a, b) => b.chatTime - a.chatTime);
  }

  getChatInfo(characterId, page, pageSize = 20) {
    const store = this.getStore();
    const chatInfo = store[characterId] || {};
    const { list = [] } = chatInfo;
    return {
      ...chatInfo,
      list: paginateFromEnd(list, page, pageSize).data,
    };
  }

  storeChat(characterId, data, characterInfo = {}) {
    const store = this.getStore();
    let chatInfo = store[characterId] || {};
    chatInfo = { ...chatInfo, ...characterInfo };
    if (!chatInfo.list) chatInfo.list = [];
    const { list } = chatInfo;
    list.push({
      chatTime: Date.now(),
      ...data,
    });
    store[characterId] = chatInfo;
    setItem(KEY, store);
  }

  // updateChatBg() {
  updateChatBg(characterId, chatBgImage) {
    const store = this.getStore();
    let chatInfo = store[characterId] || {};
    chatInfo = { ...chatInfo, ...{ chatBgImage } };
    store[characterId] = chatInfo;
    setItem(KEY, store);
  }

  // updateUnlockImage
  updateUnlockImage(characterId, unlockList) {
    const store = this.getStore();
    const chatInfo = store[characterId] || {};
    const { list = [] } = chatInfo;
    list.map((im) => {
      if (im.msgType === 'selfie' && im.type === 'lock') {
        unlockList.map((item) => {
          if (item.id === im.selfie_id) {
            im.type = 'unlock';
            im.content = item.url;
          }
          return item;
        });
      }
      return im;
    });
    store[characterId] = chatInfo;
    setItem(KEY, store);
  }

  // updateUnlockVideo
  updateUnlockVideo(characterId, unlockList) {
    const store = this.getStore();
    const chatInfo = store[characterId] || {};
    const { list = [] } = chatInfo;
    debugger;
    list.map((im) => {
      if (im.msgType === 'video' && im.type === 'lock') {
        unlockList.map((item) => {
          if (item.id === im.video_id) {
            im.type = 'unlock';
            im.content = item;
          }
          return item;
        });
      }
      return im;
    });
    store[characterId] = chatInfo;
    setItem(KEY, store);
  }

  removeChat(characterId) {
    const store = this.getStore();
    delete store[characterId];
    setItem(KEY, store);
  }
}

export default new ChatSession();
